var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    { staticClass: "rounded elevation-4 mt-2", attrs: { dense: "" } },
    [
      _c(
        "v-list-item-avatar",
        { attrs: { color: "primary" } },
        [_c("v-icon", { attrs: { dark: "" } }, [_vm._v(" mdi-account ")])],
        1
      ),
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _vm._v(" " + _vm._s(_vm.SessionData.member.name)),
          ]),
          _vm.currentBreakpoint
            ? _c("v-list-item-subtitle", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("common.label_adressNumber")) +
                    " " +
                    _vm._s(_vm.SessionData.member.addressNumber) +
                    " "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-list-item-action",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    top: "",
                    color: _vm.$vuetify.theme.dark
                      ? "yellow darken-3"
                      : "blue darken-3",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "mr-4",
                                  attrs: {
                                    color: _vm.$vuetify.theme.dark
                                      ? "yellow darken-3"
                                      : "blue darken-3",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleDarkmode()
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm.$vuetify.theme.dark
                                ? _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v(" mdi-weather-sunny "),
                                  ])
                                : _c("v-icon", { attrs: { color: "white" } }, [
                                    _vm._v(" mdi-weather-night "),
                                  ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm.$vuetify.theme.dark
                    ? _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("common.label_displayModeChangeLight")
                          ),
                        },
                      })
                    : _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("common.label_displayModeChangeDark")
                          ),
                        },
                      }),
                ]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "", color: "error" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    color: "red",
                                    disabled: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleLogoutClick()
                                    },
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v(" mdi-logout "),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("common.label_logout_user", [
                            _vm.SessionData.member.name,
                          ])
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }